import React from "react";

const ShopButton = ({
  text = "Shop Now",
  theme = "light",
  outlined,
  background,
  textColor,
  arrow = false,
  padding,
  buttonStyle = {},
  containerStyles,
  onClick,
  disabled = false,
  textStyles,
}) => {

  const buttonStyles = theme === "dark" ? styles.darkButton : styles.lightButton;

  return (
    <div style={{ display: "flex", justifyContent: "center", ...containerStyles }}>
      <button
        onClick={(e) => {
          e.preventDefault();
          onClick && onClick(e);
        }}
        css={{
          ...styles.baseButton,
          ...buttonStyles,
          ...(outlined ? styles.outlinedButton : {}),
          ...(background ? { background: background } : {}),
          ...(textColor ? { color: textColor } : {}),
          ...(padding ? { padding: padding } : {}),
          ...(Object.keys(buttonStyle).length > 0 ? { ...buttonStyle } : {}),
          ...(disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}),
          ...(disabled ? { pointerEvents: "none" } : {}),
          ...(disabled ? { background: "silver" } : {}),
        }}
      >
        <div css={{ paddingRight: arrow ?? 15, ...(textColor && { color: textColor }), ...(arrow !== false && { marginRight: 5 }), ...textStyles, }}>{text}</div>
        <span css={{ ...textStyles }}>{arrow !== false && "→"}</span>
      </button>
    </div >
  );
};

export default ShopButton;

const styles = {
  baseButton: {
    margin: "10px 0",
    borderRadius: 50,
    padding: "12px 24px",
    fontSize: ".9rem",
    fontWeight: 700,
    cursor: "pointer",
    border: "none",
    width: "100%",
    maxWidth: 600,
    transition: "background 0.3s ease, color 0.3s ease",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  lightButton: {
    background: "white",
    color: "black",
  },
  darkButton: {
    background: "black",
    color: "white",
  },
  outlinedButton: {
    background: "white",
    border: "1px solid black",
  },
};
